import { neutrals, brand } from 'src/theme/colors';
import { StyleSheet } from 'react-native';
import { FOCUS_COLOR } from 'src/theme-v2/focus';

export const style = StyleSheet.create({
  main: {
    height: '100%',
    borderWidth: 3,
    borderRadius: 11,
    borderColor: 'transparent',
  },
  border: {
    borderColor: brand.main.water,
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    borderRadius: 8,
  },
  button: {
    width: '100%',
    height: '100%',
    borderWidth: 1,
    borderColor: 'transparent',
    borderRadius: 10,
    padding: 1,
  },
  buttonFocus: { borderColor: FOCUS_COLOR },
  badge: {
    width: 21,
    height: 21,
    position: 'absolute',
    top: 12,
    right: 12,
    backgroundColor: neutrals.white,
    borderRadius: 10,
    shadowColor: neutrals.black,
    shadowOpacity: 0.3,
    shadowRadius: 2,
    shadowOffset: {
      width: 0.5,
      height: 0.5,
    },
    justifyContent: 'center',
    alignItems: 'center',
  },
  badgeText: {
    fontWeight: 700,
    fontSize: 14,
    lineHeight: 21,
    color: brand.main.water,
  },
  check: {
    width: 24,
    height: 24,
    borderWidth: 1,
    borderColor: neutrals.white,
    borderRadius: 12,
    position: 'absolute',
    bottom: 12,
    right: 12,
    backgroundColor: brand.main.water,
    shadowColor: neutrals.black,
    shadowOpacity: 0.3,
    shadowRadius: 4,
    shadowOffset: {
      width: 1,
      height: 1,
    },
    padding: 5,
  },
  delete: {
    width: 24,
    height: 24,
    borderRadius: 12,
    position: 'absolute',
    right: 12,
    top: 12,
    backgroundColor: neutrals.white,
    shadowColor: neutrals.black,
    shadowOpacity: 0.3,
    shadowRadius: 4,
    shadowOffset: {
      width: 1,
      height: 1,
    },
    padding: 5,
  },
});
